import { ModalContainer, SwitchAppButton } from "../../components";
import signupSuccessfulImage from "../../assets/images/signup-successful.png";

interface ISignUpSuccessfulProps {
  isModalOpen: boolean;
  closeModal: () => void;
  isLoadingResendConfirmationEmail: boolean;
  resendEmailConfirmationLink: () => void;
}

export const SignUpSuccessfulModal = ({
  isModalOpen,
  closeModal,
  isLoadingResendConfirmationEmail,
  resendEmailConfirmationLink,
}: ISignUpSuccessfulProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      selectorPrimaryFocus="button.cds--btn--primary"
    >
      <div className="signup-success-modal col flex-container justify-content--center align-items--center">
        <img
          src={signupSuccessfulImage}
          alt="signup successful"
          className="signup-successful-image mb-5"
        />

        <h2 className="font-ctm--bold mt-5 mb-5">Signup Successful!</h2>

        <div className="flex-box flex-container col align-items--center justify-content--center">
          <span>You have successfully registered on SwitchApp</span>

          <h5 className="text-danger font-ctm--bold mt-5">
            Please check your email for the confirmation link to complete the
            registration.
          </h5>
        </div>

        <div className="flex-box get-started-section">
          <h5 className="font-ctm--semibold">Didn't get the email yet?</h5>
        </div>

        <SwitchAppButton
          kind="primary"
          size="md"
          className="go-to-login-button mt-5"
          onClick={resendEmailConfirmationLink}
          disabled={isLoadingResendConfirmationEmail}
        >
          Resend Verification Link
        </SwitchAppButton>
      </div>
    </ModalContainer>
  );
};
